import React from "react";
import { TextField, Alert, Box } from "@mui/material";
import { AuthLayout } from "../../../shared/components/layout/AuthLayout";
import OtpIllustration from "../../../assets/illustrations/otp.svg";
import { VALIDATOR_REQUIRE, VALIDATOR_EMAIL } from "../../../shared/utils/validators";
import FormButton from "../../../shared/components/ui/FormButton";

const ConfirmEmailView = ({
  confirmationFormState,
  confirmationInputHandler,
  handleTextInputChange,
  handleSignUpConfirmation,
  loginState,
  setLoginState,
  isActionLoading,
  textFieldStyle,
}) => {
  return (
    <AuthLayout
      title="Verify Your Email"
      subtitle="Enter the 6-digit code sent to your email"
      illustration={OtpIllustration}
    >
      {loginState.message && (
        <Alert
          severity="info"
          className="mb-2"
          onClose={() => setLoginState({ state: "confirm", message: null })}
        >
          {loginState.message}
        </Alert>
      )}
      <Box component="form" onSubmit={handleSignUpConfirmation}>
        <TextField
          label="Email"
          name="email"
          type="email"
          value={confirmationFormState.inputs.email.value}
          onChange={(e) =>
            handleTextInputChange(e, confirmationInputHandler, [
              VALIDATOR_REQUIRE(),
              VALIDATOR_EMAIL(),
            ])
          }
          placeholder="Enter your email"
          variant="outlined"
          fullWidth
          required
          sx={textFieldStyle}
          focused
        />

        <TextField
          label="Confirmation Code"
          name="confirmationCode"
          value={confirmationFormState.inputs.confirmationCode.value}
          onChange={(e) =>
            handleTextInputChange(e, confirmationInputHandler, [
              VALIDATOR_REQUIRE(),
            ])
          }
          placeholder="Enter the 6-digit code"
          variant="outlined"
          fullWidth
          required
          sx={textFieldStyle}
          focused
        />

        <FormButton
          type="submit"
          variant="contained"
          fullWidth
          size="medium"
          sx={{ backgroundColor: "primary.main" }}
          loading={isActionLoading}
        >
          Verify
        </FormButton>
      </Box>

      <div className="text-center mt-8">
        <span className="text-sm">Didn't receive the code? </span>
        <span
          onClick={() => setLoginState({ state: "forgot", message: null })}
          className="text-primary font-bold hover:underline cursor-pointer"
        >
          Resend
        </span>
      </div>
    </AuthLayout>
  );
};

export default ConfirmEmailView;
